import { render } from "./Vue.vue?vue&type=template&id=27e75b1a&scoped=true"
import script from "./Vue.vue?vue&type=script&lang=js"
export * from "./Vue.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-27e75b1a"

export default script